// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3lqI2","label":"Section_label__1s6sX","contentWrap":"Section_contentWrap__1kO_i","footer":"Section_footer__i1ckl","footerInner":"Section_footerInner__3mMiu"};